import { render, staticRenderFns } from "./SiteSeguro.vue?vue&type=template&id=49669fda&scoped=true&"
import script from "./SiteSeguro.vue?vue&type=script&async=true&lang=js&"
export * from "./SiteSeguro.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SiteSeguro.vue?vue&type=style&index=0&id=49669fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49669fda",
  null
  
)

export default component.exports